import * as fabric from 'office-ui-fabric-react';
import { INavLink } from 'office-ui-fabric-react';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import * as api from '../../api/generated';
import { Role, StatisticsType } from '../../enums';
import { getSideBar, setSidebar } from '../../utils';
import { useAuthentication } from '../authentication';

const Sidebar: React.FunctionComponent = () => {
    const isSidebarShown = getSideBar();

    const navigate = useNavigate();

    const { hasAccess } = useAuthentication();
    const [statisticType, setStatisticType] = useState<StatisticsType>();

    const handleClick = (event: React.MouseEvent<Element, MouseEvent> | undefined, element: fabric.INavLink | undefined) => {
        if (event !== undefined && element !== undefined) {
            event.preventDefault();
            if (element.key === 'azure') {
                window.location.href = element.url;
            } else {
                navigate(element.url);
            }
        }
    };

    useEffect(() => {
        setType();
    });

    const setType = async () => {
        if (!statisticType) {
            const type = await api.statistic.getStatisticsType();
            setStatisticType(type);
        }
    };

    function checkRoleAndStatisticsType(type: string): boolean {
        if (hasAccess(Role.Manager)) {
            if (type === 'Nugis' && statisticType === 0) {
                return true;
            } else if (type === 'PowerBI' && statisticType === 1) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    const links: Array<INavLink> = [
        {
            name: 'Pagrindinis',
            url: '/',
            icon: 'Home',
            key: '/'
        },
        {
            name: 'Administravimas',
            url: '/administration',
            icon: 'Admin',
            key: '/administration'
        },
        {
            name: 'Darbuotojų rolių administravimas',
            icon: 'Group',
            key: 'azure',
            url: 'https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade',
            disabled: !hasAccess(Role.Manager)
        },
        {
            name: 'Statistika',
            url: '/statistics/Nugis',
            icon: 'Financial',
            key: '/statistics/Nugis',
            disabled: checkRoleAndStatisticsType('Nugis')
        },
        {
            name: 'PowerBI statistika',
            url: '/statistics/PowerBi',
            icon: 'Financial',
            key: '/statistics/PowerBi',
            disabled: checkRoleAndStatisticsType('PowerBI')
        },
        {
            name: 'Eilių valdymas',
            url: '/queuesManagement',
            icon: 'DOM',
            key: '/queuesManagement',
            disabled: !hasAccess(Role.Manager)
        }
    ];

    const returnKey = (): string => {
        let returnLink = '/';
        links.map((link) => {
            if (location.pathname.includes(link.url) && location.pathname !== '/') {
                returnLink = link.url;
            }
        });
        return returnLink;
    };

    return (
        <div style={{ textAlign: 'right' }}>
            <fabric.IconButton
                id="expandButton"
                iconProps={{ iconName: isSidebarShown ? 'DoubleChevronLeftMed' : 'DoubleChevronLeftMedMirrored' }}
                styles={{ root: { textAlign: 'right', width: '50px', height: '40px' } }}
                onClick={() => setSidebar(!isSidebarShown)}
            />
            <fabric.Nav
                theme={fabric.getTheme()}
                selectedKey={returnKey()}
                onLinkClick={(e, el) => handleClick(e, el)}
                groups={[
                    {
                        links: links
                    }
                ]}
                styles={{
                    link: {
                        paddingLeft: '7px'
                    }
                }}
            />
        </div>
    );
};

export default Sidebar;
